import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import classNames from "classnames";
import "./styles.css";

interface InfoBoardProps {
  result: any[];
}

const InfoBoard: React.FC<InfoBoardProps> = ({ result }) => {
  const [total, setTotal] = useState(0);
  const [colors, setColors] = useState<string[]>([]);
  const [transitioningColors, setTransitioningColors] = useState<{[key: string]: number;}>({});

  const availableColors = ["#ff0000", "#006eff", "#ffe200", "#29ff7b"];

  useEffect(() => {
    const initialColorMap: { [key: string]: number } = {};
    availableColors.forEach((color) => { initialColorMap[color] = 0; });

    setColors(availableColors);
    setTransitioningColors(initialColorMap);

    const totalSum = result.reduce((acc, res) => acc + parseInt(res.number), 0);
    setTotal(totalSum);

    const colorMap: { [key: string]: number } = { ...initialColorMap };
    result.forEach((res) => {
      const color = res.colorCode;
      if (!colorMap[color]) {
        colorMap[color] = 1;
      } else {
        colorMap[color] += 1;
      }
    });

    let delay = 0;
    Object.entries(colorMap).forEach(([color, count]) => {
      if (count > 0) {
        for (let i = 1; i <= count; i++) {
          delay += 700;
          setTimeout(() => {
            setTransitioningColors((prev) => ({
              ...prev,
              [color]: i,
            }));
          }, delay);
        }
      }
    });
  }, [result]);

  return (
    <div
      style={{ width: "16rem" }}
      className="pt-xl-2 h-100 d-flex flex-column gap-2"
    >
      <div className="my-2 ml-2 d-flex text-center justify-content-center align-items-center text-white">
        <h5 className="me-2">Suma</h5>
        <h1 className="fw-bold">
          <CountUp end={total} />
        </h1>
      </div>

      <div className="game-card mb-3 d-flex justify-content-between">
        <div
          className={classNames("game-result-indicator w-100", {
            active: total < 75.5,
          })}
        >
          <h5>Debajo</h5>
          <h5>75.5</h5>
        </div>
        <div
          className={classNames("game-result-indicator w-100", {
            active: total > 75.5,
          })}
        >
          <h5>Arriba</h5>
          <h5>75.5</h5>
        </div>
      </div>

      <div className="game-card mb-3 d-flex justify-content-between align-items-center">
        <div
          className={classNames(
            "my-auto game-result-indicator d-flex align-items-center justify-content-center w-100",
            { active: total % 2 === 0 }
          )}
        >
          <h5 className="my-auto">Par</h5>
        </div>
        <div
          className={classNames(
            "my-auto game-result-indicator d-flex align-items-center justify-content-center w-100",
            { active: total % 2 === 1 }
          )}
        >
          <h5 className="my-auto">Impar</h5>
        </div>
      </div>

      <div className="color-card d-flex flex-column px-3 py-2">
        <div className="text-white text-center">
          <h3>Color</h3>
        </div>

        {[5, 4, 3, 2, 1, 0].map((threshold) => (
          <div
            key={threshold}
            className="d-flex color-row py-1 text-white justify-content-between"
          >
            <h5 className="my-auto">{threshold}+</h5>
            <div className="available-colors mx-auto d-flex align-items-center my-auto">
              {colors.map((color) => {
                const count = transitioningColors[color] || 0;
                if (count === threshold) {
                  return (
                    <div
                      key={color}
                      className="slide-in-elliptic-left-fwd-enter-active result-color mx-1 my-auto"
                      style={{ backgroundColor: color }}
                    ></div>
                  );
                }
                return null;
              })}
            </div>
            <h5 className="my-auto"></h5>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoBoard;
